import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from '@pella/sash-framework';

import CardRenderer from '../../../common/card-types/card-renderer';

import styles from './index.module.scss';

const CompetitiveBoxes = ({ data, className }) => {
	if (!data) return null;

	return (
		<div className={`${styles.compBoxes_Grid} mt-4 md:mt-6 md:grid ${!data.card?.[0] ? styles.compBoxes_Grid_1 : ''} ${className || ''}`}>
			{data.feature?.[0] && (
				<div>
					<Carousel
						wrapperClassName='[&>div]:h-full'
						className={styles.compBoxes_Slider}
						slidesToShow={{ xs: 1, md: 3 }}
						showDots
					>
						{data.feature.map((box, index) => (
							<div
								key={index}
								className={`${styles.compBoxes_Box} relative h-full bg-gray-3 p-6 md:p-8`}
							>
								<span className={`${styles.compBoxes_BoxNumber} mb-6 flex items-center justify-center rounded-full bg-gray-70 text-base font-semibold text-primary md:mb-8 xl:text-xl`}>{index + 1}</span>
								<h3
									className='mb-5'
									dangerouslySetInnerHTML={{ __html: box.heading }}
								/>
								<div dangerouslySetInnerHTML={{ __html: box.description }} />
							</div>
						))}
					</Carousel>
				</div>
			)}

			{data.card?.[0] && (
				<div className={`${styles.compBoxes_Ad} mt-4 md:mt-0`}>
					<CardRenderer
						data={data.card[0]}
						className='text-white'
					/>
				</div>
			)}
		</div>
	);
};

CompetitiveBoxes.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default CompetitiveBoxes;
